import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetRouteScroll } from "../lib/resetRouteScroll";

/**
 * Public marketing/auth pages scroll `window`, not `#main-content`.
 * Authenticated `Layout` already resets the shell scrollport; this covers
 * in-app footer and other internal navigations that stay outside Layout.
 *
 * useLayoutEffect so the destination paints at top (useEffect leaves one
 * frame at the previous page's clamped scrollY).
 */
export function RouteScrollReset() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    resetRouteScroll();
  }, [pathname]);

  return null;
}
